import {
  Boxes,
  Building2,
  Cable,
  CalendarClock,
  DatabaseZap,
  MapPin,
  RefreshCw,
  Send,
  ServerCog,
  SlidersHorizontal,
  Unlink,
} from 'lucide-react'
import type { NavigationGroup } from './types'

export const NAVIGATION_GROUPS: readonly NavigationGroup[] = [
  {
    label: 'Tenancy',
    items: [
      {
        label: 'Tenant groups',
        to: '/tenant-groups',
        icon: Boxes,
        singularLabel: 'tenant group',
      },
      {
        label: 'Tenants',
        to: '/tenants',
        icon: Building2,
        singularLabel: 'tenant',
      },
      {
        label: 'Configs',
        to: '/configs',
        icon: SlidersHorizontal,
        singularLabel: 'config',
      },
    ],
  },
  {
    label: 'Inventory',
    items: [
      {
        label: 'Inventory system profiles',
        to: '/inventory-system-profiles',
        icon: ServerCog,
        singularLabel: 'inventory system profile',
      },
      { label: 'Venues', to: '/venues', icon: MapPin, singularLabel: 'venue' },
    ],
  },
  {
    label: 'Operations',
    items: [
      {
        label: 'Rebuild inventory',
        to: '/actions/rebuild-inventory',
        icon: RefreshCw,
      },
      {
        label: 'Rebuild config cache',
        to: '/actions/rebuild-config-cache',
        icon: DatabaseZap,
      },
      {
        label: 'Redrive performance update',
        to: '/actions/redrive-performance-update',
        icon: CalendarClock,
      },
      {
        label: 'Redrive tenant group',
        to: '/actions/redrive-tenant-group',
        icon: Send,
      },
    ],
  },
  {
    label: 'Maintenance',
    items: [
      {
        label: 'ISP to venues',
        to: '/isp-to-venues',
        icon: Cable,
        singularLabel: 'ISP to venue mapping',
      },
      {
        label: 'Unlinked venues',
        to: '/unlinked-venues',
        icon: Unlink,
      },
    ],
  },
]
